import { createContext, useContext } from "react";

/** Interface */
interface IOrderFormContext {
	getItemIndex: (id: string) => number;
	/**
	 * Where a load carrier sits in the form's `loadCarriers` array, or -1 before the array has been
	 * synced to the carrier list. The Leergut tab lists every carrier, so the array mirrors that
	 * list by position rather than holding only the ones being ordered.
	 */
	getLoadCarrierIndex: (id: string) => number;
	isProjectLocked?: boolean;
	/** Which sites the project picker offers — see `ProjectSearch`'s own `scope`. */
	projectScope?: "organization" | "ownProjects";
}

/** Context */
export const OrderFormContext = createContext<IOrderFormContext>({} as IOrderFormContext);

/** Hooks */
export function useOrderFormContext() {
	return useContext(OrderFormContext);
}
